import { EbookPage } from './EbookPage'
import { withEbookPage } from './withEbookPage'

const Connected = withEbookPage(EbookPage)

export { Connected as EbookPage }
